import React, { Component } from 'react';
import axios from 'axios';
import { Button, Col, Label, Progress, Row, UncontrolledAlert } from 'reactstrap';
import { Field, FormGroup } from '@availity/form';

import PropTypes from 'prop-types';
import housingstore from '../../WA_TPA_FCS_Form/stores/housingstore';


class AddFile extends Component {

	constructor(props) {
		super(props);
		// Initialize the component's state
		this.state = {
			percetComp: undefined,
			documentName: null,
			fileName: null,
			fileError: null,
			option: undefined,
			supportedExt: [".jpg", ".jpeg", ".tiff", ".pdf"]
		};
	}

	componentDidMount() {
		this.setState({ documentName: this.props.propsData.documentName })
		this.setState({ option: this.props.propsData.option })
		const filename = this.props.propsData.attachment;
				if (filename !== undefined){
			this.setState({ fileName: filename });
			this.setState({ percetComp: 100 });
		}else{
			this.setState({ fileName: null });
			this.setState({ percetComp: undefined });
		}
		this.setState({ fileError: null });
	}

	componentWillUnmount() {
		const inpName = this.props.propsData.documentName.replaceAll(" ", "_") + "_value";
		this.props.setErrorMessage(inpName, true);
	}

	onFileUpload = (e, fileId) => {
		// this.setState({percentageCompleted: undefined})
		const { files } = e.target;
		if (files && files.length > 0) {
			const file = files[0]
			const ext = file.name.slice(file.name.lastIndexOf("."))
			this.setState({ fileName: file.name })
			// validate file Size
			const maxSize = 10 * 1024 * 1024;

			if (!this.state.supportedExt.includes(ext)) {
				this.setState({ percetComp: -1 })

				this.setState({ fileError: "File extension ".concat(ext).concat(" not supported") });
				this.setErrorMessage(fileId);
			}
			else if (file.size > maxSize) {
				this.setState({ percetComp: -1 })
				this.setState({ fileError: "Upload unsuccessful due to file size exceeding 10MB. Please try again with a smaller file size." });
				this.setErrorMessage(fileId);
			}
			else {
				const pacificTime = new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"});
				const updatedFileName = `${housingstore.getProviderAgencyAbbr()}_${housingstore.memberInfo.memProvOne}WA_${housingstore.shortenDocName(this.state.documentName)}_${pacificTime.replace(/\//g, "_").replace(/:/g,"_").replace(", ", "_").replace(" ", "_").concat("_PST")}${ext}`
				const formData = new FormData();
				// const metaData = { fileName: file.name, folderCheckByApp:"HOUSING", bucket:"assessment", documentName: this.state.documentName };
				const metaData = { fileName: updatedFileName, folderCheckByApp:"HOUSING", bucket:"assessment", documentName: this.state.documentName };
				formData.append('metadata', JSON.stringify(metaData));
				formData.append('file', file);
				axios.post('/SupportiveHousingAssessment/EN/upload/provconn/v1/attachments/file/assessment', formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data',
							'meta-transid': crypto.randomUUID()
						},
						onUploadProgress: this.uploadProgress
					}).then(res => {
						this.setState({ percetComp: 100 })
						housingstore.setSupportiveHousingAttachmentsDetails(this.state.documentName, file.name, this.state.option, updatedFileName)
					}).catch(error => {
						this.setState({ percetComp: -1 })
						this.setErrorMessage(fileId);
					});
			}
		}
	}

	uploadProgress = (progressEvent) => {

		const { lengthComputable, loaded, total } = progressEvent;

		if (lengthComputable) {
			let percentage = Math.round((loaded * 100) / total);
			percentage = percentage && percentage === 100 ? 90 : percentage;
			if (percentage) {
				this.setState({ percetComp: percentage })
			}
		}
	}

	removeFile = () => {
		this.setState({ percetComp: undefined });
		this.setState({ fileName: null });
		this.setState({ fileError: null });
		const docIndex = housingstore.attachments.findIndex(attac => attac.documentName === this.props.propsData.documentName);
		housingstore.attachments = housingstore.attachments.slice(0, docIndex).concat(housingstore.attachments.slice(docIndex + 1));
	}

	handleBtnClick = (fileId) => {
	  document.getElementById(fileId).click();
	}


	setErrorMessage= (fileId) => {
		const errorMessage = {};
		errorMessage[fileId] = "File upload failed. Please try again.";
		this.props.setErrorMessage(errorMessage);
	}

	render() {
		const { percetComp, documentName, fileName, fileError, ext } = this.state;
		const fileId = this.props.propsData.documentName.replaceAll(" ", "_") + "_id"
		const inpName = this.props.propsData.documentName.replaceAll(" ", "_") + "_value"; 
		return (
			<div>
				<Row>
					<Col sm="12">
						<Label>
							<b>
								Important:
							</b> Individual file size cannot exceed <span className='text-danger'>10MB</span>. Supported file types include <span className='text-danger'>.jpg, .jpeg, .tiff, .pdf</span>.
						</Label>
					</Col>
				</Row>
				<div className="mt-3" />
				{(percetComp === undefined || percetComp === -1) &&
					<Row>
					<Col sm="12" className='uploadFileDocument'>
							<FormGroup className='label-font'>
								<div>
									<Button aria-label='Add file' className='btn btn-link btn-file upload-button' color='primary' outline onClick={() => this.handleBtnClick(fileId)}>
										<i className="icon icon-plus-circle"/> 
										<span className="add-file">Add file</span>
									</Button>
									<Field
										type='file'
										id={fileId}
										name={fileId}
										onChange={(e) => this.onFileUpload(e, inpName)}
										style={{display: 'none'}}
										accept={this.state.supportedExt.join(",")}
										aria-label="upload files"
										value={null}
									/>
									<Field
										type='text'
										name={inpName}
										style={{display: 'none'}}
									/>
								</div>
							</FormGroup>
						</Col>
					</Row>
				}
				{percetComp !== undefined &&
					<>
						<Row className="pl-32 mt-3 align-items-center">
							<Col sm="5">
								<label id={fileId}><strong>{fileName}</strong></label>
							</Col>

							{
								fileError !== null ?
									<>
										<Col sm="6">
											<label className='text-danger'>{fileError}</label>
										</Col>
										<Col sm="1">
											<Button aria-label='Remove file' color="link" className="text-danger px-0" onClick={this.removeFile}>
												<i className="icon icon-trash-empty" />
											</Button>
										</Col>
									</>
									:
									<>
										<Col sm="6">
											<Progress barAriaLabelledBy={fileId} value={(() => { if (percetComp < 0) return 100; return percetComp; })()} color={(() => { if (percetComp === 100) return 'success'; if (percetComp === -1) return 'danger'; return 'primary' })()} />
										</Col>
										<Col sm="1">
											<Button aria-label='Remove file' color="link" className="text-danger px-0" onClick={this.removeFile}>
												<i className="icon icon-trash-empty" />
											</Button>
										</Col>
									</>
							}
						</Row>
						{(percetComp === 100 || percetComp === -1) &&
							<Row className="pl-32 mt-3">
								<Col>
									<UncontrolledAlert color={percetComp === 100 ? 'success' : 'danger'} fade>
										<strong>
											{percetComp === 100 ? 'Upload successfull..!' : 'Upload unsuccessfull..!'}
										</strong>
									</UncontrolledAlert>
								</Col>
							</Row>
						}
					</>
				}

			</div >
		);

	}
}

export default AddFile;

AddFile.propTypes = {
	propsData: PropTypes.object,
	setErrorMessage: PropTypes.func
};
